// Pure, shared form validators — unit-tested and reused across the add/edit
// dialogs so validation rules don't drift between screens.

// Pragmatic email shape check: non-empty local part, "@", domain with a dot.
// Not RFC-perfect (no validator is) but rejects the common mistakes.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isBlank(value) {
  return value == null || String(value).trim() === "";
}

export function isValidEmail(email) {
  return typeof email === "string" && EMAIL_RE.test(email.trim());
}

// Inline error for an email field that has been typed into: empty is left to the
// required-field/disabled-Save signal, a malformed value gets a helpful message.
export function emailFormatError(email) {
  if (isBlank(email)) {
    return "";
  }
  return isValidEmail(email) ? "" : "Enter a valid email address";
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Normalize an optional UUID field for a request body. Backend optional UUIDs are
// pointer types (`*uuid.UUID`) that accept null, but google/uuid still fails to
// unmarshal an empty or malformed string ("invalid UUID length: 0"). Anything
// that isn't a real UUID — unset "", or the "null"/"undefined" strings that
// `"" + value` coercion can produce — becomes null so the decode doesn't crash.
export function uuidOrNull(value) {
  return typeof value === "string" && UUID_RE.test(value.trim()) ? value.trim() : null;
}
